import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import CheckIcon from '@mui/icons-material/Check';
import max from 'lodash/max';
import { Fragment, ReactElement, useMemo } from 'react';

// Core.
import { ILearnerCredit } from 'core';

interface IBoardCreditsProps {
  abbreviation: string;
  credits: ILearnerCredit[];
}

export const BoardCredits = (props: IBoardCreditsProps): ReactElement => {
  const { abbreviation, credits = [] } = props;
  const isAccepted: boolean = useMemo(() => credits.some(({ isAccepted }) => isAccepted), [credits]);
  const totalCredits: number = useMemo(() => max(credits.map(({ totalCredits }) => totalCredits)), [credits]);
  const units: string = useMemo(() => credits[0]?.units || 'Points', [credits]);

  return (
    <>
      <Grid container size={{ xs: 1 }} sx={{ justifyContent: 'flex-end' }}>
        {isAccepted ? <CheckIcon sx={{ colorPrimary: { fill: '#82bc00' } }} /> : ' '}
      </Grid>
      <Grid size={{ xs: 11 }}>
        <strong>
          {totalCredits} Total {abbreviation} {units}
        </strong>
      </Grid>
      {credits.map(
        ({ acceptedCredits: amount, name }: ILearnerCredit, index: number): ReactElement => (
          <Fragment key={index}>
            <Grid size={{ xs: 1 }} />
            <Grid size={{ xs: 11 }}>
              <Box sx={{ ml: 2 }}>
                {amount || 0} {name}
              </Box>
            </Grid>
          </Fragment>
        ),
      )}
    </>
  );
};
